import { GetServerSidePropsContext, NextPageContext } from 'next';
import { COOKIES_CONFIG } from '@belong/common';
import { parseCookies } from 'nookies';
import { ApiClient, getJwtToken } from 'src/utils/api-client';
import { buildApiClient, buildOctaneClient } from 'src/utils/build-api-client';

const { TRACKING_ID, JWT_TOKEN } = COOKIES_CONFIG;

export function buildServerClient(
  ctx?: NextPageContext | GetServerSidePropsContext,
  jwtOverride?: string,
): ApiClient {
  const cookies = parseCookies(ctx);

  const trackingId = cookies[TRACKING_ID.name];
  let jwtToken = cookies[JWT_TOKEN.name] || getJwtToken();

  if (jwtOverride) {
    jwtToken = jwtOverride;
  }

  const apiClient = buildApiClient(jwtToken, trackingId);

  return apiClient;
}

export function buildOctaneServerClient(
  ctx?: NextPageContext | GetServerSidePropsContext,
  jwtOverride?: string,
): ApiClient {
  const cookies = parseCookies(ctx);

  const trackingId = cookies[TRACKING_ID.name];
  let jwtToken = cookies[JWT_TOKEN.name] || getJwtToken();

  if (jwtOverride) {
    jwtToken = jwtOverride;
  }

  return buildOctaneClient(jwtToken, trackingId);
}
